var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "plus_24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.66668 7.83325H12.1667V8.16659H8.66668H8.16668V8.66659V12.1666H7.83334V8.66659V8.16659H7.33334H3.83334V7.83325H7.33334H7.83334V7.33325V3.83325H8.16668V7.33325V7.83325H8.66668Z",
    fill: "#727C8D",
    stroke: "#068EFE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusDark);
export default __webpack_public_path__ + "static/media/plus-dark.821d94c6233d1d53c84c61358320a856.svg";
export { ForwardRef as ReactComponent };